import React from "react";

type Props = {
	payload: {
		form: { name: string };
		questions: { text?: string }[];
	};
};

export const ReviewFormPreview = ({ payload }: Props): React.ReactElement => {
	const visible = payload.questions.slice(0, 6);
	const remainder = payload.questions.length - visible.length;

	return (
		<div className="space-y-4">
			<div className="flex items-baseline gap-3">
				<div className="text-heading-3 font-semi-bold text-neutral-9 tabular-nums">
					{payload.questions.length}
				</div>
				<div className="text-paragraph-3 text-neutral-7">
					question{payload.questions.length === 1 ? "" : "s"} in this form
				</div>
			</div>

			<ul className="space-y-2">
				{visible.map((question, ii) => (
					<li
						key={ii}
						className="flex items-start gap-3 rounded-sm bg-neutral-1 px-3 py-3 ring-1 ring-neutral-2"
					>
						<span className="mt-px w-6 shrink-0 text-caption font-semi-bold text-neutral-7 tabular-nums">
							{String(ii + 1).padStart(2, "0")}
						</span>
						<span className="text-paragraph-3 text-neutral-9">{question.text ?? "(question)"}</span>
					</li>
				))}
			</ul>

			{remainder > 0 && (
				<div className="pl-3 text-caption text-neutral-7">
					+ {remainder} more question{remainder === 1 ? "" : "s"} not shown
				</div>
			)}
		</div>
	);
};

export default ReviewFormPreview;
